// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run pnpm gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../schema/public';

import { gql } from '@apollo/client';
import { ScoreFragmentDoc } from './ScoreFragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TournamentClaimPrizeMutationVariables = Types.Exact<{
  scoreId: Types.Scalars['String']['input'];
}>;


export type TournamentClaimPrizeMutation = { __typename?: 'Mutation', casinoTournamentsPublicClaimPrizeMutation?: { __typename?: 'CasinoTournamentsPublicClaimPrizeMutationPayload', success?: boolean, errors?: Array<{ __typename?: 'CasinoTournamentsPublicError', message?: string }>, score?: { __typename?: 'CasinoTournamentsPublicScore', id: string, username?: string, points?: string, position?: number, isMyScore?: boolean, canClaimPrize?: boolean } } };


export const TournamentClaimPrizeMutationDocument = /*#__PURE__*/ gql`
    mutation TournamentClaimPrizeMutation($scoreId: String!) {
  casinoTournamentsPublicClaimPrizeMutation(input: {scoreId: $scoreId}) {
    success
    errors {
      message
    }
    score {
      ...ScoreFragment
    }
  }
}
    ${ScoreFragmentDoc}`;
export type TournamentClaimPrizeMutationMutationFn = Apollo.MutationFunction<TournamentClaimPrizeMutation, TournamentClaimPrizeMutationVariables>;
export function useTournamentClaimPrizeMutation(baseOptions?: Apollo.MutationHookOptions<TournamentClaimPrizeMutation, TournamentClaimPrizeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TournamentClaimPrizeMutation, TournamentClaimPrizeMutationVariables>(TournamentClaimPrizeMutationDocument, options);
      }
export type TournamentClaimPrizeMutationHookResult = ReturnType<typeof useTournamentClaimPrizeMutation>;
export type TournamentClaimPrizeMutationMutationResult = Apollo.MutationResult<TournamentClaimPrizeMutation>;
export type TournamentClaimPrizeMutationMutationOptions = Apollo.BaseMutationOptions<TournamentClaimPrizeMutation, TournamentClaimPrizeMutationVariables>;